<template>
  <v-container>
    <h1>Betalingsmetoder for {{ vendor.name }}</h1>

    <AdminBreadcrumbs :vendor="vendor" tail-text="Betalingsmetoder" />

    <v-card class="orange lighten-5" elevation="3">
      <v-form ref="form" lazy-validation @submit.prevent="submit">
        <v-card-title class="white--text orange">
          Rediger betalingsmetoder
        </v-card-title>

        <v-container>
          <v-checkbox
            v-model="vendor.vipps_enabled"
            :disabled="!isMethodConfigured('vipps')"
            label="Vipps"
            class="mt-0"
          />
          <v-checkbox
            v-model="vendor.stripe_enabled"
            :disabled="!isMethodConfigured('stripe')"
            label="Stripe"
            class="mt-0"
          />
          <v-checkbox
            v-model="vendor.offline_enabled"
            :disabled="!isMethodConfigured('offline')"
            label="Offline"
            class="mt-0"
          />
        </v-container>

        <v-card-actions>
          <v-btn type="submit" color="success">
            <v-icon left> mdi-content-save </v-icon>
            Lagre innstillinger
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-container>
</template>

<script>
import backend from "@/backend";
import AdminBreadcrumbs from "@/components/AdminBreadcrumbs";

export default {
  name: "AdminVendorPayment",

  components: {
    AdminBreadcrumbs,
  },

  props: {
    vendorId: {
      type: String,
      required: true,
      default: "",
    },
  },

  data: function () {
    return {
      vendor: {},
      isSaving: false,
      rules: {
        required: (v) => !!v || "Required",
      },
    };
  },

  async created() {
    this.vendor = await backend.get(`vendors/${this.vendorId}/`);
  },

  methods: {
    isMethodConfigured(method) {
      // Vendor might still be loading in a higher up component
      if (typeof this.vendor.configured_payment_methods != "undefined") {
        return this.vendor.configured_payment_methods.includes(method);
      } else {
        return false;
      }
    },

    async submit() {
      if (this.$refs.form.validate()) {
        this.isSaving = true;

        this.vendor = await backend.put(
          `vendors/${this.vendor.id}/`,
          {
            name: this.vendor.name,
            organization: this.vendor.organization,
            stripe_enabled: this.vendor.stripe_enabled,
            vipps_enabled: this.vendor.vipps_enabled,
            offline_enabled: this.vendor.offline_enabled,
          },
          {
            vendor: this.vendorId,
          }
        );

        this.$router.push({
          name: "adminVendorDetail",
          params: {
            vendorId: this.vendor.id.toString(),
          },
        });

        this.$store.dispatch("add", {
          type: "success",
          message: "Betalingsmetoder er nå lagret.",
        });

        this.isSaving = false;
      }
    },
  },
};
</script>

